import { gql } from 'graphql-tag'

import { FRAGMENT_AVATAR_USER } from '@/components/Worlds/UI/Avatar/Avatar.hasura'

const FRAGMENT_CONVERSATION_AVATARS_WORLD = gql`
  fragment ConversationAvatarsWorld on world {
    id
    icon_url
    primary_color
  }
`

export const FRAGMENT_CONVERSATION_AVATARS_CONVERSATION = gql`
  fragment ConversationAvatarsConversation on conversation {
    id
    session {
      id
      world {
        ...ConversationAvatarsWorld
      }
      session_hosts {
        role
        user {
          ...AvatarUser
        }
      }
    }
    series {
      id
      world {
        ...ConversationAvatarsWorld
      }
      series_hosts {
        role
        user {
          ...AvatarUser
        }
      }
    }
    conversation_users {
      id
      user {
        ...AvatarUser
      }
    }
  }
  ${FRAGMENT_AVATAR_USER}
  ${FRAGMENT_CONVERSATION_AVATARS_WORLD}
`
